import React, { Component } from 'react';
import { CircularProgress, RaisedButton } from 'material-ui';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import 'firebase/functions';
import { translate as t } from 'admin-on-rest';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import theme from '../utils/theme';
import { authenticateUser } from '../utils/auth-utils';

class LoginPage extends Component {
  state = { loading: true };
  componentWillMount = async () => {
    try {
      await authenticateUser();
      this.setState({ loading: false });
      if (window.location.hash === '#/login') {
        this.props.dispatch(push('/'));
      }
    } catch (error) {
      this.setState({ loading: false });
    }
  };
  render() {
    const { translate } = this.props;
    const { loading } = this.state;

    const muiTheme = getMuiTheme(theme);

    const authEndpoint =
      process.env.NODE_ENV === 'production'
        ? 'https://auth.pinchos.se'
        : 'http://localhost:3000';

    const login = () => {
      window.location.replace(
        `${authEndpoint}?redirectTo=${window.location.origin}${
          window.location.pathname
        }&useParse=true${
          process.env.NODE_ENV === 'production' ? '' : '&parseStage=staging'
        }`
      );
    };

    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div className="login-form">
          <img
            alt="Pinchos Logo"
            className="logo"
            src="/android-chrome-192x192.png"
          />
          <h1>{translate('catalog-title')}</h1>
          {loading ? (
            <div>
              <CircularProgress id="loading-progress" />
            </div>
          ) : (
            <RaisedButton primary onClick={login}>
              Log in
            </RaisedButton>
          )}
        </div>
      </MuiThemeProvider>
    );
  }
}

export default connect(
  () => {},
  (dispatch) => ({
    dispatch,
  })
)(t(LoginPage));
